import { useCallback } from 'react';
import UILink from 'UIComponents/link/UILink';
import { isIdle, isLoading, isRejected } from '../common/types/FetchStatus';
import { getRecordHref } from './internal/getRecordHref';
import { useAssociatedObjectsRecord } from './internal/useAssociatedObjectsRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociatedRecordLink = ({
  children,
  className,
  LinkComponent = UILink,
  LinkComponentProps = {},
  objectId,
  objectTypeId,
  onTrackClick
}) => {
  const associatedRecord = useAssociatedObjectsRecord(objectTypeId, objectId);
  const handleClick = useCallback(() => {
    if (onTrackClick) {
      onTrackClick({
        objectId,
        objectTypeId
      });
    }
  }, [objectId, objectTypeId, onTrackClick]);
  if (isIdle(associatedRecord) || isLoading(associatedRecord) || isRejected(associatedRecord) || !associatedRecord.data) {
    return /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(LinkComponent
  // Keep UILinkComponentProps at the top so HubSpotAppLink props override matching ones
  , Object.assign({}, LinkComponentProps, {
    className: className,
    external: true,
    href: getRecordHref(associatedRecord.data.objectTypeId, associatedRecord.data.objectId),
    onClick: handleClick,
    children: children
  }));
};
export default AssociatedRecordLink;